<template>
    <div :style="[$vuetify.breakpoint.xs ? {'padding': '30px'} : {'padding': '50px'}]">
        <h4> Program to filter out users who are already signed up </h4>
        <b-form-group class="mt-3" description="Only .csv file accepted" label="Select file">
            <b-form-file
                v-model="file"
                placeholder="Choose file or drop it here..."
                drop-placeholder="Drop file here..."
                accept=".csv"
            ></b-form-file>
        </b-form-group>
        <b-button variant="outline-success" @click="getCount()">Go</b-button>
        <ul class='mt-3'>
            <li v-for="user in notSign" v-bind:key="user">{{user}}</li>
        </ul>
    </div>
</template>

<script>
const papa = require("papaparse");
const fb = require("../firebaseConfig.js");

export default {
    data() {
        return {
            notSign: [],
            userData: [],
            file: null
        };
    },
    methods: {
        getCount() {
            papa.parse(this.file, {
                header: true,
                skipEmptyLines: true,
                complete: results => {
                    this.userData = results.data;
                    this.userData.forEach(item => {
                        const email = item.email;
                        fb.usersCollection
                            .where("email", "==", email)
                            .get()
                            .then(querySnapshot => {
                                if (querySnapshot.empty) {
                                    this.notSign.push(email);
                                }
                            });
                    });
                }
            });
        }
    }
};
</script>